import React from 'react';
import SearchClose from '../assets/images/SearchCloseIcon.svg';

export default () => {
  return <img src={SearchClose} alt="" />;
};
